import { search } from 'jmespath'
import { spanSchema } from '../schemas/span'
import { withParsedData } from './base'

export const SpanRenderer = withParsedData(spanSchema)<{ source?: object }>(({ parsedData, source }) => {
  const { text } = parsedData

  // 使用 JMESPath 在 source 对象中查找变量，替换为变量值
  const result = text.replace(/\$\{(\w+)\}/g, (_match, varName) => {
    return search(source, varName) ?? ''
  })

  return <span>{result}</span>
})
